import { CircleAlert } from "lucide-react";
import { motion } from 'motion/react';
import { useAppSelector } from '../../store';
import { getEnabledCollaboration } from '../../store/siteInfoSlice';

export const DisabledComments = () => {
    const collaborationEnabled = useAppSelector(getEnabledCollaboration)

    return (
        <>
            {!collaborationEnabled && (
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -50 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                    className="rounded-lg border border-red-500/50 px-4 py-3 text-white bg-destructive w-[96vw] md:max-w-[1000px] mx-auto mt-4"
                    style={{ boxShadow: '0 0 0 1px color-mix(in oklab, #0000330f, #f0f0f3 25%), 0 12px 40px #00000026, 0 12px 34px #00005506, 0 12px 26px -20px #00062e12' }}
                >
                    <p className="text-sm text-center">
                        <CircleAlert
                            className="-mt-0.5 me-3 inline-flex"
                            size={16}
                            strokeWidth={2}
                            aria-hidden="true"
                        />
                        Comments are disabled for this site.
                        Comments are disabled, however you can still view existing tasks.
                        If you'd like to create new tasks and make changes to existing tasks, please contact an admin.
                    </p>
                </motion.div>
            )}
        </>
    );
}
export default DisabledComments;